import * as React from "react";
import { StyleSheet } from "react-native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { useMediaQuery } from "react-responsive";

import InicioScreen from "../screens/mainScreens/InicioScreen";
import BuscarScreen from "../screens/mainScreens/BuscarScreen";
import AddScreen from "../screens/mainScreens/AddScreen";
import InversionesScreen from "../screens/mainScreens/InversionesScreen";
import PerfilScreen from "../screens/mainScreens/PerfilScreen";

import { Ionicons } from "@expo/vector-icons";

const Tab = createBottomTabNavigator();

//TEMAS
import { useTheme } from "@react-navigation/native";

const Tabs = () => {
  const { colors } = useTheme();

  const isSmall = useMediaQuery({
    maxDeviceWidth: 1334,
    // alternatively...
    query: "(max-device-width: 1334px)",
  });
  let donde="beside-icon"
  isSmall?donde="below-icon":donde="beside-icon"


  const isTabletOrMobileDevice = useMediaQuery({
    maxDeviceWidth: 1224,
    // alternatively...
    query: "(max-device-width: 1224px)",
  });

  let shown=0
  isTabletOrMobileDevice?shown=-100:shown=0

  return (
    <Tab.Navigator
      screenOptions={({ route }) => ({
        tabBarLabelPosition: donde,
        tabBarShowLabel: true,
        tabBarItemStyle: {
          maxWidth: "fit-content",
          marginHorizontal: 10,
          borderRadius: 20,
          marginVertical: 10,
          justifyContent: "flex-start",
          paddingLeft: 30,
          paddingRight: 20,
        },
        tabBarActiveBackgroundColor: colors.main,
        tabBarLabelStyle: {
          fontFamily: "Kodchasan-Bold",
          fontSize: 16,
        },
        tabBarStyle: {
          position: "absolute",
          height: 70,
          maxWidth: "fit-content",
          top: shown,
          left: 200,
          elevation: 0,
          zIndex: 10,
          backgroundColor: "#00000000",
          borderWidth: 0,
          borderColor: colors.background,
          flexDirection: "row",
          justifyContent: "flex-start",
        },
        tabBarIcon: ({ color, size }) => {
          let iconName;

          if (route.name === "Inicio") {
            iconName = "ios-home";
          } else if (route.name === "Explorar") {
            iconName = "ios-search";
          } else if (route.name === "Añadir fondos") {
            iconName = "ios-add";
          } else if (route.name === "Mis inversiones") {
            iconName = "ios-trending-up";
          } else if (route.name === "Perfil") {
            iconName = "ios-person";
          }

          // You can return any component that you like here!
          return <Ionicons name={iconName} size={size} color={color} />;
        },
        tabBarActiveTintColor: colors.buttonTextColor,
        tabBarInactiveTintColor: colors.mainTransparency,
      })}
    >
      <Tab.Screen
        name="Inicio"
        component={InicioScreen}
        options={{
          headerShown: false,
        }}
      />
      <Tab.Screen
        name="Explorar"
        component={BuscarScreen}
        options={{
          headerShown: false,
        }}
      />
      <Tab.Screen
        name="Añadir fondos"
        component={AddScreen}
        options={{
          headerShown: false,
        }}
      />
      <Tab.Screen
        name="Mis inversiones"
        component={InversionesScreen}
        options={{
          headerShown: false,
        }}
      />
      <Tab.Screen
        name="Perfil"
        component={PerfilScreen}
        options={{
          headerShown: false,
        }}
      />
    </Tab.Navigator>
  );
};

const styles = StyleSheet.create({
  shadow: {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: -5,
    },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 5,
  },
  shadowDown: {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 2,
  },
});

export default Tabs;
